/** ************************************************************************
 * Atomic Component for the bPerx iFrame UI.
 *
 * Atomic Type: Content, dynamic (content that changes with state)
 * Purpose: Display the number of issues, and the name of, the magazine
 *
 * @file   Atomic Component, content dynamic, chosen magazine text
 * @author Paul J Stales
 * @since  2.2.0
 ************************************************************************ */

import { FunctionalComponent, h } from 'preact'
import { css } from 'aphrodite'
import { IFRAME_CLASSNAMES } from '../../../../../../common/constants/ConstantsIFrameClassNames'

/**
 * Props Interface for Chosen Magazine Text
 */
interface ChosenMagazineTextProps {
  styles: { [key: string]: any }
  numberOfIssues?: number
  wordChoiceForIssue?: string
  magazineTitle?: string
  isOptingIn: boolean
  optedOutText?: string
}

/**
 * This is the text that is displayed concerning the chosen magazine.
 *
 * If the customer is opting in, it displays the number of issues in
 * the offer, along with the magazine title.
 * Else the customer is opting out, then it displays a message saying
 * they are opted out, and can opt back in if they wish to do so.
 * @param ChosenMagazineTextProps
 * @returns
 */
const ChosenMagazineText: FunctionalComponent<ChosenMagazineTextProps> = ({
  styles,
  numberOfIssues,
  wordChoiceForIssue,
  magazineTitle,
  isOptingIn,
  optedOutText
}) => {
  return (
    <div>
      {isOptingIn && (
        <h4
          class={`${IFRAME_CLASSNAMES.BPERX_CHOSEN_MAGAZINE_TEXT}${' '}${
            styles[IFRAME_CLASSNAMES.BPERX_CHOSEN_MAGAZINE_TEXT] === undefined
              ? ''
              : css(styles[IFRAME_CLASSNAMES.BPERX_CHOSEN_MAGAZINE_TEXT])
          }`}
        >
          <span
            class={`${IFRAME_CLASSNAMES.BPERX_CHOSEN_MAGAZINE_ISSUES}${' '}${
              styles[IFRAME_CLASSNAMES.BPERX_CHOSEN_MAGAZINE_ISSUES] ===
              undefined
                ? ''
                : css(styles[IFRAME_CLASSNAMES.BPERX_CHOSEN_MAGAZINE_ISSUES])
            }`}
          >
            {numberOfIssues}
          </span>{' '}
          {wordChoiceForIssue !== undefined ? wordChoiceForIssue : 'issues of '}
          <span
            class={`${IFRAME_CLASSNAMES.BPERX_CHOSEN_MAGAZINE_TITLE}${' '}${
              styles[IFRAME_CLASSNAMES.BPERX_CHOSEN_MAGAZINE_TITLE] ===
              undefined
                ? ''
                : css(styles[IFRAME_CLASSNAMES.BPERX_CHOSEN_MAGAZINE_TITLE])
            }`}
          >
            {magazineTitle}
          </span>
        </h4>
      )}
      {!isOptingIn && (
        <h4
          class={`${IFRAME_CLASSNAMES.BPERX_CHOSEN_MAGAZINE_TEXT}${' '}${
            styles[IFRAME_CLASSNAMES.BPERX_CHOSEN_MAGAZINE_TEXT] === undefined
              ? ''
              : css(styles[IFRAME_CLASSNAMES.BPERX_CHOSEN_MAGAZINE_TEXT])
          }`}
        >
          {optedOutText ? optedOutText : 'You are opted out.'}
        </h4>
      )}
    </div>
  )
}

export default ChosenMagazineText
